<template>
  <div>
    <video
      style="display: none"
      id="remoteMonitorVideo"
      ref="video"
      class="canvas"
      autoPlay
      playsinline
    ></video>
<!--    :width="videoWidth"-->
<!--    :height="videoHeight"-->
    <canvas
      id="canvas"
      style="display: none"
      ref="canvas"
      class="canvas"
    ></canvas>
  </div>
</template>

<script>
import { Toast } from "vant";
import Janus from "@/assets/js/janus";
import { RefreshUserInfo } from "@/services/login";
import { SaveMonitorLog } from "@/services/monitor";
import { doSend } from "@/utils/websocket";
import {lockPatientMonitor, releasePatientMonitor, UploadImage} from "@/services";

export default {
  name: "monitor",
  data() {
    return {
      // 定期截图用
      videoWidth: 500,
      videoHeight: 400,
      // janus用
      janus: null,
      janus_server: process.env.VUE_APP_JANUS_SERVER,
      opaqueId: "videoroomtest-" + Janus.randomString(12),
      sfutest: null,
      // room用
      myroom: null,
      hanguproom: null,
      publishers_num: 20,
      mypvtid: null,
      myid: null,
      // 所有远程已订阅的媒体流信息
      feeds: [],
      // 不包括自己，所有用户的stream信息
      feedStreams: [],
      houseOwner: null,
      // 医生log用
      patient_id: null,
      successTimer: null,
      // 患者用
      publishStatus: false,
      needPublish: false,
      // 通话用
      remoteVideo: null,
      localStream: null,
      // 统计监视人数用
      watching_list: [],
      // 拍照间隔
      holdingTime: 5000,
      // ai模式flag
      ai_mode:false,
      ai_watching_list :[],
      ai_stream:null,
      ai_camera_time:null,
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    doMethods(params) {
      // dz认证相关
      if (params["method"] !== "quitMonitor") {
        this.$emit("monitor", {
          toPage: "dzAndroid",
          method: "temporaryStopDz",
        });
      } else {
        this.$emit("monitor", { toPage: "dzAndroid", method: "recoveryDz" });
      }
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      if (params["method"] == "startMonitor") {
        // 患者主动进入监护模式
        // 生成roomId
        if (!this.myroom) {
          this.myroom = this.createRoomId(userInfo.id);
          this.needPublish = false;
          this.JanusInit();
        }
      } else if (params["method"] == "joinMonitor") {
        // 医生进入监护模式详情页面
        this.myroom = this.createRoomId(params["id"]);
        this.patient_id = params["patient_id"];
        this.ai_mode = params["ai_mode"];
        this.JanusInit();
      } else if (params["method"] == "openPatientMonitor") {
        // 医生想要打开患者的后台监护模式
        Toast.loading({
          mask: true,
          message: "",
          duration: 0,
          forbidClick: true,
        });
        // 移动到onremotetrack的时候才关闭loading
        let msg = {
          send_type: "openPatientMonitor",
          ai_mode : params["ai_mode"],
          to_users: [params["patient_id"]],
        };
        doSend(JSON.stringify(msg));
        // 最好是等患者先进
        setTimeout(() => {
          this.$router.push({
            path: "/monitorRoom",
            query: {
              type: "joinMonitor",
              id: params["id"],
              patient_id: params["patient_id"],
              ai_mode :params["ai_mode"],
            },
          });
        }, 2000);
        if (this.successTimer) {
          clearTimeout(this.successTimer);
        }
        this.successTimer = setTimeout(() => {
          this.successTimer = null;
          Toast.clear();
          Toast("監視モードをオンにできませんでした。");
          this.$router.go(-1);
        }, 30000);
      } else if (params["method"] == "startBackgroundMonitor") {
        // 患者后台进入监护模式
        if(params["ai_mode"]){
          // 高速模式
          this.ai_mode = true;
        }
        //生成roomId
        if (!this.myroom) {
          this.myroom = this.createRoomId(userInfo.id);
          this.needPublish = true;
          this.JanusInit();
        }
      } else if (params["method"] == "quitMonitor") {
        // 退出监护模式
        this.doHangup();
      }else if(params["method"] == "startAiAnalysis"){
        this.holdingTime = params["time"];
        // 延迟个5秒 等待其他资源加载
        this.holdingMonitorWithTime(5000);
      }
    },
    createRoomId(value) {
      let num = parseInt(value);
      return 1000000000 + num;
    },
    async JanusInit() {
      this.$emit("monitor", {
        toPage: "app",
        method: "setMyRoom",
        myroom: this.myroom,
      });
      let userRet = await RefreshUserInfo();
      let userInfo = userRet.data.data.user;
      localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(userInfo));
      this.userInfo = userInfo;
      Janus.init({
        debug: "all",
        callback: () => {
          if (!Janus.isWebrtcSupported()) {
            alert("No WebRTC support... ");
            return;
          }
          this.createJanusSession();
        },
      });
    },
    createJanusSession() {
      let serverStunUrl = "turn:43.154.16.102:3478";
      if (window.location.host.indexOf("tmp") === -1) {
        serverStunUrl = "turn:35.78.136.103:3478";
      }
      let iceServers = [
        { urls: serverStunUrl, username: "lqf", credential: "123456" },
      ];
      this.janus = new Janus({
        server: this.janus_server,
        iceServers: iceServers,
        success: () => {
          //创建session成功时
          //添加插件！
          this.attachVideoRoom();
        },
        error: function (error) {
          Janus.error(error);
        },
        destroyed: function () {},
      });
    },
    attachVideoRoom() {
      //在初期化成功之后，调用此函数
      this.janus.attach({
        plugin: "janus.plugin.videoroom",
        opaqueId: this.opaqueId,
        success: (pluginHandle) => {
          //插件初始化成功时!
          this.sfutest = pluginHandle;
          this.createRoom();
          setTimeout(() => {
            this.registerRoomUser();
          }, 1500);
        },
        error: (error) => {
          Janus.error("  -- Error attaching plugin...", error);
        },
        consentDialog: (on) => {
          //如果没有权限，这里需要让用户给权限？
        },
        iceState: (state) => {
          //iceState 主要用于标识 ICE 连接的状态，包括新建连接、连接中、连接成功等状态
          console.log("ICE state changed to " + state);
        },
        mediaState: (medium, on, mid) => {
          console.log("mediaState changed to " + on);
        },
        webrtcState: (on) => {
          console.log("webrtcState changed to " + on);
          this.sfutest.send({
            message: { request: "configure", bitrate: 256000 },
          });
        },
        slowLink: (uplink, lost, mid) => {
          //网络不好的时候调用，这时候应该关闭自己的视频，但通过chrome测试好像没有触发！
          console.log("network slow!");
        },
        onmessage: (msg, jsep) => {
          console.log("收到消息！！！！！！！！！！");
          console.log(msg);
          //当收到消息时调用
          //获取event的类型
          let event = msg["videoroom"];
          if (event) {
            if (event === "joined") {
              //当自己加入到房间时
              //myid: 不确定代表什么
              this.myid = msg["id"];
              //mypvtid：加入房间之后，应该是代表自己的id，后面会用于订阅别人
              this.mypvtid = msg["private_id"];
              if (msg["publishers"]) {
                this.newRemoteFeed(msg["publishers"]);
              }
              if (this.needPublish) {
                this.publishMyFeed();
              }
              if (this.userInfo.type === "4") {
                SaveMonitorLog({
                  patient_id: this.patient_id,
                  room_id: this.myroom,
                  type: "join",
                }).then((res) => {});
              }
            } else if (event === "destroyed") {
              // TODO: 这里需要做什么处理呢
              Janus.warn("The room has been destroyed!");
            } else if (event === "event") {
              console.log(msg);
              // 收到event：自己的stream，新的发布者（有人加入），有人离开，有人不发布了，error
              if (msg["streams"]) {
                //实际意义不大—？
                let streams = msg["streams"];
                for (let i in streams) {
                  let stream = streams[i];
                  stream["id"] = this.myid;
                }
              } else if (msg["publishers"]) {
                console.log("有发布者加入");
                if (msg["publishers"]) {
                  this.newRemoteFeed(msg["publishers"]);
                }
              } else if (msg["joining"]) {
                console.log("加入中！！！！！！！！！！！！！！");
                console.log(msg);
                if (this.userInfo.type == "5") {
                  this.watching_list.push(msg["joining"].id);
                  if(msg['joining'].display.startsWith("ai")){
                    this.ai_watching_list.push(msg["joining"].id);
                  }
                  this.publishMyFeed();
                }
              } else if (msg["leaving"]) {
                // 页面刷新时，会先触发unpublished，然后触发 leaving
                //删除离开者
                console.log("有人离开");
                console.log(msg);
                let leaving = msg["leaving"];
                if (this.userInfo.type == "5") {
                  let getLocation = this.watching_list.indexOf(leaving);
                  if (getLocation !== -1) {
                    this.watching_list.splice(getLocation, 1);
                  }
                  let getLocation2 = this.ai_watching_list.indexOf(leaving);
                  if (getLocation2 !== -1) {
                    this.ai_watching_list.splice(getLocation2, 1);
                  }
                  if(this.ai_watching_list.length == 0){
                    this.ai_mode = false;
                  }
                  if (this.userInfo.type == "5" && this.watching_list.length == 0) {
                    if (this.$route.path == "/monitorRoom") {
                      this.unpublishFeed();
                    } else {
                      this.doHangup();
                    }
                  }
                }
                if (leaving === "ok") {
                  Janus.videoPageDestory();
                  if (this.userInfo.type === "4") {
                    SaveMonitorLog({
                      patient_id: this.patient_id,
                      room_id: this.hanguproom,
                      type: "leave",
                    }).then((res) => {
                      this.hanguproom = null;
                    });
                    if (this.$route.path == "/monitorRoom") {
                      this.$router.go(-1);
                    }
                  }
                  return;
                }
              } else if (msg["unpublished"]) {
                var unpublished = msg["unpublished"];
                if (unpublished === "ok") {
                  if (this.userInfo.type === "5") {
                    this.publishStatus = false;
                  }
                  return;
                }
                if (unpublished == this.houseOwner) {
                  Toast("相手方は現在通話中。");
                  this.doHangup();
                }
              } else if (msg["error"]) {
                if (msg["error_code"] === 426) {
                  // This is a "no such room" error: give a more meaningful description
                  console.log("error! room does not exist!");
                } else {
                  console.log(msg["error"]);
                }
              }
            }
          } else {
            console.error("event is null!");
          }
          //handleRemoteJsep
          if (jsep) {
            this.sfutest.handleRemoteJsep({ jsep: jsep });
            //TODO: 这里需要判断本地音视频流是否未获取成功，比如被拒绝
          }
        },
        onlocaltrack: (track, on) => {
          console.log("onlocaltrack");
          // 记录一下发布的流 结束的时候关掉
          if (!on) {
            return;
          }
          if (track.kind === "video") {
            let stream = new MediaStream([track]);
            this.localStream = stream;
          }
        },
        onremotetrack: (track, mid, on) => {
          console.log("onremotetrack");
        },
        oncleanup: () => {},
      });
    },
    publishMyFeed() {
      if (this.publishStatus) {
        return;
      }
      this.publishStatus = true;
      //发布自己
      //tracks:设置音频，视频等,recv 为什么是false
      let tracks = [];
      tracks.push({ type: "audio", capture: true, recv: false });
      tracks.push({
        type: "video",
        capture: true,
        recv: false,
        simulcast: false,
      });
      tracks.push({ type: "data" });
      //每个参与房间的用户都会通过信令服务器相互交换等待发送和接收音视频媒体流的信息
      this.sfutest.createOffer({
        tracks: tracks,
        customizeSdp: (jsep) => {},
        success: (jsep) => {
          console.log("create offer success!");
          // 第一次加载，不加载发布不出来
          // 设置vido和audio的false或者true并不起作用，不管发送什么都是一样效果
          let publish = { request: "configure" };
          this.sfutest.send({ message: publish, jsep: jsep });
        },
        error: (error) => {
          //发生错误时，暂不处理
          Janus.error("WebRTC error:", error);
        },
      });
    },
    newRemoteFeed(list) {
      console.log(list);
      for (let f in list) {
        console.log(list[f]);
        if (list[f]["dummy"]) continue;
        if (list[f]["display"][0] !== "p") {
          continue;
        }
        console.log("订阅远程");
        let id = list[f]["id"];
        this.houseOwner = id;
        let display = list[f]["display"];
        let streams = list[f]["streams"];
        streams[0].useVideo = false;
        streams[0].useAudio = false;
        for (let i in streams) {
          let stream = streams[i];
          stream["id"] = id;
          stream["display"] = display;
        }
        let findIndex = -1;
        for (let i = 0; i < this.feedStreams.length; i++) {
          if (this.feedStreams[i][0].id == id) {
            findIndex = i;
          }
        }
        //避免同一个人的视频被多次添加！
        //未加载成功时，显示视频的loading
        streams[0].showLoading = true;
        if (findIndex != -1) {
          this.feedStreams[findIndex] = streams;
        } else {
          this.feedStreams.push(streams);
        }
        console.log(this.feedStreams);

        //加入到本地
        let remoteFeed = null;
        this.janus.attach({
          plugin: "janus.plugin.videoroom",
          opaqueId: this.opaqueId,
          success: (pluginHandle) => {
            remoteFeed = pluginHandle;
            remoteFeed.remoteTracks = {};
            remoteFeed.remoteVideos = 0;
            remoteFeed.simulcastStarted = false;

            //
            let subscription = [];
            for (let i in streams) {
              let stream = streams[i];
              subscription.push({
                feed: stream.id, // This is mandatory
                mid: stream.mid, // This is optional (all streams, if missing)
              });
              // FIXME Right now, this is always the same feed: in the future, it won't
              remoteFeed.rfid = stream.id;
              remoteFeed.rfdisplay = this.escapeXmlTags(stream.display);

              //去掉loading的显示
              this.feedStreams.forEach((item) => {
                if (item[0].id == stream.id) {
                  item[0].showLoading = false;
                }
              });
            }

            var subscribe = {
              request: "join",
              room: this.myroom,
              ptype: "subscriber",
              streams: subscription,
              //use_msid 不知道具体功能
              use_msid: false,
              private_id: this.mypvtid,
            };
            remoteFeed.send({ message: subscribe });
          },
          error: (error) => {
            Janus.error("  -- Error attaching plugin...", error);
          },
          iceState: (state) => {
            Janus.log(
              "ICE state (feed #" + remoteFeed.rfindex + ") changed to " + state
            );
          },
          webrtcState: (on) => {
            //远程流的状态!
            remoteFeed.send({
              message: { request: "configure", bitrate: 256000 },
            });
          },
          slowLink: (uplink, lost, mid) => {
            console.log("slow!");
          },
          onmessage: (msg, jsep) => {
            let event = msg["videoroom"];
            if (msg["error"]) {
              console.log(msg["error"]);
            } else if (event) {
              if (event === "attached") {
              } else if (event === "event") {
                let substream = msg["substream"];
                let temporal = msg["temporal"];
                if (
                  (substream !== null && substream !== undefined) ||
                  (temporal !== null && temporal !== undefined)
                ) {
                  if (!remoteFeed.simulcastStarted) {
                    remoteFeed.simulcastStarted = true;
                  }
                }
              }
            }

            if (jsep) {
              let stereo = jsep.sdp.indexOf("stereo=1") !== -1;
              // Answer and attach
              remoteFeed.createAnswer({
                jsep: jsep,
                tracks: [{ type: "data" }],
                customizeSdp: (jsep) => {
                  if (stereo && jsep.sdp.indexOf("stereo=1") == -1) {
                    // Make sure that our offer contains stereo too
                    jsep.sdp = jsep.sdp.replace(
                      "useinbandfec=1",
                      "useinbandfec=1;stereo=1"
                    );
                  }
                },
                success: (jsep) => {
                  let body = { request: "start", room: this.myroom };
                  remoteFeed.send({ message: body, jsep: jsep });
                },
                error: (error) => {
                  Janus.error("WebRTC error:", error);
                },
              });
            }
          },
          //不会调用local，无需处理
          onlocaltrack: (track, on) => {
            console.log("onlocaltrack");
          },
          onremotetrack: (track, mid, on) => {
            console.log("onremotetrack");
            if (!on) {
              if (track.kind === "audio") {
                delete remoteFeed.remoteTracks[mid];
                if (
                  JQuery("#remoteMonitorAudio").get(0) &&
                  JQuery("#remoteMonitorAudio").get(0) !== null
                ) {
                  Janus.attachMediaStream(JQuery("#remoteMonitorAudio").get(0), null);
                }
              } else {
                delete remoteFeed.remoteTracks[mid];
                if (
                  JQuery("#remoteMonitorVideo").get(0) &&
                  JQuery("#remoteMonitorVideo").get(0) !== null
                ) {
                  Janus.attachMediaStream(JQuery("#remoteMonitorVideo").get(0), null);
                }
              }
              return;
            }
            if (this.successTimer) {
              clearTimeout(this.successTimer);
            }
            Toast.clear();
            console.log(remoteFeed.rfid);
            console.log(this.feedStreams);
            if (remoteFeed.spinner) {
              remoteFeed.spinner.stop();
              remoteFeed.spinner = null;
            }
            if (track.kind === "audio") {
              let stream = new MediaStream([track]);
              remoteFeed.remoteTracks[mid] = stream;

              Janus.attachMediaStream(JQuery("#remoteMonitorAudio").get(0), stream);
            } else if (track.kind === "video") {
              let stream = new MediaStream([track]);
              remoteFeed.remoteTracks[mid] = stream;
              Janus.attachMediaStream(JQuery("#remoteMonitorVideo").get(0), stream);
            }
          },
          ondata: (data) => {
            console.log(data);
          },
          oncleanup: () => {
            if (remoteFeed.spinner) remoteFeed.spinner.stop();
            remoteFeed.spinner = null;
            //delete
            //这里通过v-if来处理？
            remoteFeed.remoteTracks = {};
            remoteFeed.remoteVideos = 0;
          },
        });
      }
    },
    doHangup() {
      // 挂断
      var hangup = { request: "leave" };
      this.sfutest.send({ message: hangup });
      this.sfutest.hangup();
      if (this.userInfo.type === "5") {
        this.publishStatus = false;
        if (this.watching_list.length == 0) {
          this.destroyRoom(this.myroom);
        }
        Janus.stopAllTracks(this.localStream);
      }
      this.hanguproom = this.myroom;
      this.myroom = null;
      // app.vue 的monitorRoom置空
      this.$emit("monitor", { toPage: "app", method: "setMyRoom", myroom: "" });
    },
    unpublishFeed() {
      // 停止发布
      var unpublish = { request: "unpublish" };
      this.sfutest.send({ message: unpublish });
    },
    destroyRoom(myroom) {
      var destroy = {
        request: "destroy",
        room: myroom,
        permanent: false,
      };
      this.sfutest.send({ message: destroy });
    },
    createRoom() {
      var created = {
        request: "create",
        room: this.myroom,
        permanent: false,
        is_private: false,
        publishers: this.publishers_num,
        notify_joining: true,
      };
      this.sfutest.send({ message: created });
    },
    registerRoomUser() {
      let name = Math.round(Math.random() * (9999 - 1000) + 1000) + "";
      if (this.userInfo.type == "5") {
        name = "p" + name;
      }else if (this.ai_mode) {
        name = "ai"+name;
      }
      // 患者以p开头
      var register = {
        request: "join",
        room: this.myroom,
        ptype: "publisher",
        display: name,
      };
      this.sfutest.send({ message: register });
    },
    escapeXmlTags(value) {
      if (value) {
        var escapedValue = value.replace(new RegExp("<", "g"), "&lt");
        escapedValue = escapedValue.replace(new RegExp(">", "g"), "&gt");
        return escapedValue;
      }
    },

    holdingMonitorWithTime(time){
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      if(this.ai_mode){
        this.holdingTime = 2000;
        // 高速模式
        lockPatientMonitor({patient_id: userInfo.login_account_id,});
      }else{
        this.holdingTime = 5000;
        // 低速模式
        releasePatientMonitor({patient_id: userInfo.login_account_id,});
      }
      setTimeout(() => {
        this.holdingMonitor();
      }, time);
    },
    async holdingMonitor() {
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      if(userInfo.monitor_open_flg !== "1" || userInfo.ai_analysis_flg !== "1"){
        // 未开启监护模式 和 AI分析 1m后重试
        this.holdingMonitorWithTime(60000);
        if(this.ai_stream){
          console.log("摄像头需要关闭");
          this.ai_stream.getTracks().forEach(track => track.stop());
          this.ai_stream = null;
        }
        return;
      }
      if(this.ai_stream){
        console.log("摄像头开启中");
        // 判断摄像头已经开启了多久
        const currentTime = new Date();
        const timeDifference = Math.floor((currentTime - this.ai_camera_time) / 1000);
        // 5分钟 5*60
        if(timeDifference >= 300){
          console.log("摄像头需要重启");
          this.ai_stream.getTracks().forEach(track => track.stop());
          this.ai_stream = null;
          // 休息3秒钟
          this.holdingMonitorWithTime(3000);
          return;
        }
        let context = this.$refs.canvas.getContext('2d');
        context.drawImage(this.$refs.video, 0, 0, this.videoWidth, this.videoHeight);
        const imgData = this.$refs.canvas.toDataURL('image/png');
        const blob = this.dataURLtoBlob(imgData);
        const fileName = `${userInfo.login_account_id}-${Date.now()}.png`;
        let formData = new FormData();
        formData.append('image', blob, fileName);
        let res = await UploadImage(formData);
        if (res && res.data.code >= 0) {
          // 上传成功等待下一次
          this.holdingMonitorWithTime(this.holdingTime);
        }else{
          // 上传失败 30s后重试
          this.holdingMonitorWithTime(30000);
        }
      }else{
        console.log("摄像头启动");
        // 获取摄像头资源并设置
        const constraints = {
          audio: false,
          video: { width: this.videoWidth,height: this.videoHeight,transform: "scaleX(-1)"},
        };
        navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
          this.ai_stream = stream;
          this.ai_camera_time = new Date();
          if ("srcObject" in this.$refs.video) {
            this.$refs.video.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            this.$refs.video.src = window.URL.createObjectURL(stream);
          }
          this.$refs.video.onloadedmetadata = () => {
            this.$refs.canvas.width = this.videoWidth;
            this.$refs.canvas.height = this.videoHeight;
            this.$refs.video.play();
          };
        }).catch((error) => {
          console.log(error);
          Toast("カメラ権限が異常です。");
          // 失败 30s后重试
          this.holdingMonitorWithTime(30000);
        });
        // 成功设置资源 1秒后开始截图
        this.holdingMonitorWithTime(1000);
      }
    },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      const u8arr = new Uint8Array(bstr.length);
      for(let i = 0; i < bstr.length; i++) {
        u8arr[i] = bstr.charCodeAt(i);
      }
      return new Blob([u8arr], { type: mime });
    },
  },
  watch: {},
};
</script>

<style scoped></style>
